import {
  createLogEvent as createLogEventGraphql,
  CreateLogEventMutationVariables,
  graphqlCall,
} from '@akin-home/amplify';

export const createLogEventMutation = (
  params: CreateLogEventMutationVariables
) => graphqlCall(createLogEventGraphql, params);
